import React from 'react';
import { NHAssetType} from '../../interfaces/asset';

interface IProps {
    TransformedAssetUrl: string;
    FileName:string;
    AssetType: number;
    className?: string;
}

const DisplayAsset = ({
    TransformedAssetUrl,
    FileName,
    AssetType,
    className = ''
}: IProps) => {
   
    const renderDisplayAsset = () => {
        return (
            <>
                {
                    AssetType === NHAssetType.Videos ?
                        TransformedAssetUrl.includes('staging') ?
                            <video width="288" height="176" controls src={TransformedAssetUrl}  className={className}>
                                Your browser does not support the video tag.
                            </video>
                        :
                            <video width="288" height="176" controls src={`https://www.nursinghomes.com/videos/${FileName}.mp4`}  className={className}>
                                Your browser does not support the video tag.
                            </video>
                           
                    :

                    AssetType === NHAssetType.Photos ?
                        TransformedAssetUrl.includes('staging') ?
                            <img src={TransformedAssetUrl} className={className}/>
                        :
                            <img src={`https://www.nursinghomes.com/photos/gallery-all/${FileName}.webp`}  className={className}/>
                    :

                    AssetType === NHAssetType.Logos ?
                        TransformedAssetUrl.includes('staging') ?
                            <img src={TransformedAssetUrl} className={className}/>
                        :
                            <img src={`https://www.nursinghomes.com/logos/large/${FileName}.webp`}  className={className}/>
                    :
                       
                    AssetType === NHAssetType.CardLogos ?
                        TransformedAssetUrl.includes('staging') ?
                            <img src={TransformedAssetUrl}  className={className}/>
                        :
                            <img src={`https://www.nursinghomes.com/logos/logo-review-card-online/${FileName}.webp`}  className={className}/>
                    :
                        ''
                }
            </>
        );
    };

    return renderDisplayAsset();
};

export default DisplayAsset;